/**
 * URL-hash keys for the container-types feature's deep-linkable overlays, bound
 * via `useHashDialog` / `useHashParamDialog` (see `@/hooks/use-hash-dialog`).
 * Row-scoped overlays carry the entity id as a hash param (`#edit/5`).
 *
 * Container types and sub-container types are distinct surfaces on separate
 * pages, so the sub-container keys are `sub-` prefixed to guarantee the two
 * never collide even if both listings ever share a page.
 */
export const CONTAINER_TYPES_HASH = {
  /** `#create` — ContainerTypeFormDialog in create mode. */
  create: 'create',
  /** `#edit/<id>` — ContainerTypeFormDialog editing a specific container type. */
  edit: 'edit',
  /** `#delete/<id>` — single container-type delete confirmation. */
  delete: 'delete',
  /** `#bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'bulk-delete'
} as const;

export type ContainerTypesHashKey =
  (typeof CONTAINER_TYPES_HASH)[keyof typeof CONTAINER_TYPES_HASH];

/**
 * URL-hash keys for the sub-container-types listing. Prefixed with `sub-` so
 * they stay distinct from `CONTAINER_TYPES_HASH`.
 */
export const SUB_CONTAINER_TYPES_HASH = {
  /** `#sub-create` — SubContainerTypeFormDialog in create mode. */
  create: 'sub-create',
  /** `#sub-edit/<id>` — SubContainerTypeFormDialog editing a specific row. */
  edit: 'sub-edit',
  /** `#sub-delete/<id>` — single sub-container-type delete confirmation. */
  delete: 'sub-delete',
  /** `#sub-bulk-delete` — bulk delete confirmation (action bar). */
  bulkDelete: 'sub-bulk-delete'
} as const;

export type SubContainerTypesHashKey =
  (typeof SUB_CONTAINER_TYPES_HASH)[keyof typeof SUB_CONTAINER_TYPES_HASH];
